import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ModalAddTrailService } from '../modal-add-trail.service';
import { CardTrailComponent } from '../card-trail/card-trail.component';
import { SHARED_MODULES } from '@app/shared';

@Component({
  selector: 'app-card-subdivision',
  imports: [SHARED_MODULES, CardTrailComponent],
  templateUrl: './card-subdivision.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardSubdivisionComponent {
  public modalAddTrailService = inject(ModalAddTrailService);
  @Input() public subdivision: any;

  public get isSelected(): boolean {
    return this.modalAddTrailService.isSubdivisionSelected(this.subdivision);
  }

  public onSelect(event: any) {
    event.stopPropagation();
    this.modalAddTrailService.selectSubdivision(this.subdivision, event.target.checked);
  }
}
